import { memo } from 'react';
import CustomSourceHandle from '@common-components/bt-chatbot/custom-source-handle';
import { getHandleId, getSourceHandleStyle } from '@common-services/utils';
import { NodeProps, Position } from 'reactflow';
import { CustomNodeData, nodeTypes } from '../bt-nodes-def';
import TriggerNodeContainer from './trigger-node-container';
import classes from "./trigger-node.module.scss";

function TriggerNode({ id, data }: NodeProps<CustomNodeData>) {
    const type = data?.type;
    const nodeColor = nodeTypes?.[type]?.color;

    const customStyle = {
        ...getSourceHandleStyle(nodeColor),
        right: -8,
        top: 125
    };

    return (
        <>
            <TriggerNodeContainer id={id} />
            <CustomSourceHandle
                type="source"
                position={Position.Right}
                id={getHandleId(data.handles, 'source', 0)}
                className={classes.trigger_source_handle}
                style={customStyle}
                connectioncount={1}
            />
        </>
    );
}

export default memo(TriggerNode);